import api from "./Api";

class EmitenteService {
  GetEmitente(payload) {
    return api.get("/v1/emitente/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEmitente(payload) {
    return api.post("/v1/emitente/", payload).then((response) => {
      return response.data;
    });
  }

  PutEmitente(payload) {
    return api.put("/v1/emitente/", payload).then((response) => {
      return response.data;
    });
  }

  GetLojaVirtual(payload) {
    return api.get("/v1/emitente/LojaVirtual/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEmpresasLojaVirtual(payload) {
    return api
      .get("/v1/emitente/LojaVirtual/Empresas", { params: payload })
      .then((response) => response.data);
  }

  PutLojaVirtual(payload) {
    return api
      .put("/v1/emitente/LojaVirtual/" + payload.id, payload.data, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => response.data);
  }

  DeleteEmitente(payload) {
    return api.delete("/v1/emitente/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEmitenteOData(payload) {
    return api.get("/OData/Emitente" + payload).then((response) => {
      return response.data;
    });
  }

  PostRegisterEmitente(payload) {
    return api.post("/v1/registerEmitente/", payload).then((response) => {
      return response.data;
    });
  }

  GetIntegracaoApiKeys(payload) {
    return api
      .get("/v1/integracoes/externas/admin/empresas/" + payload + "/api-keys")
      .then((response) => {
        return response.data;
      });
  }

  PostIntegracaoApiKey(payload) {
    return api
      .post(
        "/v1/integracoes/externas/admin/empresas/" +
          payload.idEmpresa +
          "/api-keys",
        payload.data
      )
      .then((response) => {
        return response.data;
      });
  }

  DeleteIntegracaoApiKey(payload) {
    return api
      .delete("/v1/integracoes/externas/admin/api-keys/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetIntegracaoConfiguracao(payload) {
    return api
      .get(
        "/v1/integracoes/externas/admin/empresas/" + payload + "/configuracao"
      )
      .then((response) => {
        return response.data;
      });
  }

  PutIntegracaoConfiguracao(payload) {
    return api
      .put(
        "/v1/integracoes/externas/admin/empresas/" +
          payload.idEmpresa +
          "/configuracao",
        payload.data
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new EmitenteService();
